module.exports = __webpack_public_path__ + "static/img/bg-pt.fcebe22b.png";